// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__fZqRW","notAvailable":"style_notAvailable__lgfta"};